import { BackArrowIcon, Heading2, IconButton } from '@ui';

import * as css from './PlaybackScreen.css';

type PlaybackHeaderProps = { onBack: () => void };

export const PlaybackHeader = ({ onBack }: PlaybackHeaderProps) => {
    return (
        <div className={css.backNavLeft}>
            <IconButton onClick={onBack} color={'white'}>
                <BackArrowIcon color="white" />
            </IconButton>
            <Heading2 color="inverse">Playback</Heading2>
        </div>
    );
};
